// Auth guard: every route below needs `/v1/me`. A 401 sends the user to /login and back.
// HARDEN-mfa: an agency operator without two-step sign-in gets the enrolment screen instead of
// any page but /account.
import { ApiError } from "@companyos/sdk";
import { useQuery } from "@tanstack/react-query";
import { createRoute, Outlet, redirect, useRouterState } from "@tanstack/react-router";
import { meQuery } from "../api/query";
import { ForcedEnrolment, mfaHold } from "../features/account/mfa";
import { SessionContext } from "../features/use-feature";
import { rootRoute } from "./__root";

export const authedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "authed",
  beforeLoad: async ({ context, location }) => {
    try {
      const me = await context.queryClient.ensureQueryData(meQuery(context.api));
      return { me };
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        throw redirect({ to: "/login", search: { redirect: location.href } });
      }
      throw error;
    }
  },
  component: function AuthedLayout() {
    const { api, me: initial } = authedRoute.useRouteContext();
    // Keeps `/me` (entitlements, memberships) fresh: refetch on focus and every 60 s.
    const { data } = useQuery({ ...meQuery(api), initialData: initial });
    const pathname = useRouterState({ select: (s) => s.location.pathname });
    // HARDEN-mfa: an operator without two-step sign-in sets it up before anything else;
    // Account & security stays open. (A company's own requirement is checked in c.$slug.)
    const hold = pathname === "/account" ? null : mfaHold(data, null);
    return (
      <SessionContext.Provider value={{ me: data, company: null }}>
        {hold ? <ForcedEnrolment api={api} me={data} reason={hold} /> : <Outlet />}
      </SessionContext.Provider>
    );
  },
});
